import { WitaConnector } from '@/services/repository/connector'

import {
  CreateChamadoTecnicoParams,
  CreateChamadoTecnicoResponse,
  EditChamadoTecnicoParams,
  EditChamadoTecnicoResponse,
  FindChamadoTecnicoByIdParams,
  FindChamadoTecnicoByIdResponse,
} from '../domain/chamado-tecnico'

const ROOT_URL = '/entity/call-tech'

export const ChamadoTecnicoService = {
  findById: async ({ callId }: FindChamadoTecnicoByIdParams) => {
    const url = ROOT_URL + `/${callId}`
    return await WitaConnector.get<FindChamadoTecnicoByIdResponse>(url)
  },

  create: async (params: CreateChamadoTecnicoParams) => {
    const url = ROOT_URL
    return await WitaConnector.post<CreateChamadoTecnicoResponse>(url, params)
  },

  edit: async ({ callId, ...params }: EditChamadoTecnicoParams) => {
    const url = ROOT_URL + `/${callId}`
    return await WitaConnector.put<EditChamadoTecnicoResponse>(url, params)
  },
}
